var sensors = window["sensorsDataAnalytic201505"];

function getElementIndex(element) {
  // 获取父元素的所有子元素
  const children = Array.from(element.parentNode.children);
  // 返回当前元素在子元素列表中的索引（从0开始）
  return children.indexOf(element);
}
function removeEmptyValues(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== null && value !== undefined && value !== ""
    )
  );
}
function getMktPage() {
  const map = {
    "/cart": "购物车",
    "/checkout": "结算页",
  };
  const pathname = window.location.pathname;
  if (map[pathname]) {
    return map[pathname];
  } else {
    if (pathname.includes("/products/")) {
      return "商品详情页";
    }
    if (pathname.includes("/collections/")) {
      return "分类页";
    }
    if (pathname.includes("/search")) {
      return "搜索结果";
    }
    if (pathname === "/") {
      return "首页";
    }
    if (pathname.includes("/blogs")) {
      return "blogs";
    }
    return "活动页";
  }
}
function getSensorsCommonParams() {
  return {
    mkt_page: getMktPage(),
    referer_page_type: "",
    referer_page: window.location.href,
    // mkt_position_number: "",
    // mkt_material_id: "", // 资源位内素材为图片链接时，传链接URL。资源位内素材为商品时，传商品SPUID/SKUID，
    // mkt_material_name: "", // 资源位为图片链接时，传物料名（banner名、活动名等）。 资源位为商品时：传商品SPU/SKU名，
    click_id: sensors.quick("getAnonymousID") + new Date().getTime(),
  };
}

function extractShopifySectionId(element) {
  const classList = Array.from(element.classList);
  const shopifyClass = classList.find((className) =>
    className.startsWith("shopify-section--")
  );

  if (!shopifyClass) {
    return null; // 没有找到匹配的类名
  }
  const id = shopifyClass.split("shopify-section--")[1];
  return id || null; // 如果提取为空则返回null
}

function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let value = window.location.search.substr(1).match(reg);
  if (value != null) {
    return unescape(value[2]);
  }
  return "";
}
function initShareId(name) {
  let shareId = getQueryString(name);
  if (!shareId) {
    shareId = localStorage.getItem("sensors_" + name) || "";
  }
  shareId && localStorage.setItem("sensors_" + name, shareId);
  return shareId;
}
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

function getExchangeRate(countryCode, callback) {
  let exchangeRate = sessionStorage.getItem("exchange_rate_" + countryCode);
  if (exchangeRate) {
    callback(exchangeRate);
    return;
  }
  if (countryCode == "US" || countryCode == "USD") {
    callback(1);
    return;
  }
  const apiUrl = `https://api.rantion-admin.com/serverApi/rantion-etl/etlData/queryCurrencyByCountryCode?countryCode=${countryCode}`;
  exchangeRate = 1;
  fetch(apiUrl, {
    method: "GET",
    timeout: 30000,
  })
    .then((response) => response.json())
    .then((response) => {
      const resData = response.data;
      if (resData && resData.countryCode === countryCode) {
        exchangeRate = resData.currency;
        sessionStorage.setItem("exchange_rate_" + countryCode, exchangeRate);
      }
      callback(exchangeRate);
    })
    .catch(() => callback(exchangeRate));
}
function registerPage(customer, exchange_rate) {
  sensors.registerPage({
    business_line: "donnerdeal",
    platform_type: function () {
      return isMobile() ? "Mobile" : "PC";
    },
    country: window.Rantion.country || "",
    currency: window.Rantion.currency,
    exchange_rate: function () {
      return exchange_rate;
    },
    is_login: function () {
      return customer != null;
    },
    sharer_id: function () {
      return initShareId("said");
    },
    share_session_id: function () {
      return initShareId("ssid");
    },
  });
}

class FoorerAndHeader {
  constructor() {
    this.init();
  }
  init() {
    // 处理页脚和页头的事件
    this.handleFooterEvents();
    this.handleHeaderEvents();
    // 单独的搜索界面
    this.handleSearchEvents();
  }
  handleHeaderEvents() {
    const summarys = document.querySelectorAll("summary");
    if (summarys) {
      summarys.forEach((summary) => {
        if (summary) {
          summary.addEventListener("click", () => {
            const url = summary.getAttribute("data-url");
            const mktClick = {
              mkt_area: "导航栏",
              mkt_position_number: summary.getAttribute("data-position_number"),
              ...getSensorsCommonParams(),
              mkt_material_id: url,
              mkt_page: "导航栏",
              referer_page_type: "导航栏",
            };
            sensors.track("mktClick", mktClick);
          });
        }
      });
    }
  }
  handleFooterEvents() {
    const headerForm = document.querySelector("#footer-newsletter");
    if (headerForm) {
      headerForm.addEventListener("submit", () => {
        // event.preventDefault();
        const emailInput = headerForm.querySelector(
          "input[name='contact[email]']"
        );
        const email = emailInput.value.trim();
        if (email) {
          sensors.track("SubscribResult", { subscribe_email: email });
        }
      });
    }
  }
  handleSearchEvents() {
    if (location.pathname.indexOf("/search") === 0) {
      const resultsCount = document.querySelector(".results-count");
      if (resultsCount) {
        const keyWord = document.querySelector(".results-count-value");
        if (keyWord) {
          sensors.track("ReturnSearchResult", {
            key_word: keyWord.value.trim(),
            keyword_type: "商品名推荐搜索词",
            result_number: resultsCount.getAttribute("data-count") || 0,
          });

          const productList = document.querySelector(".product-list");
          if (productList) {
            productList.addEventListener("click", (event) => {
              const product = event.target.closest("a");
              function getSku() {
                const card = event.target.closest(".product-card");
                if (card) {
                  return card.getAttribute("data-skuid");
                }
                return "";
              }
              if (product) {
                const name = product.getAttribute("alt");
                const price = product.getAttribute("sku_price") / 100;
                const sku = product.getAttribute("data-skuid");
                let SearchResultClick = {
                  key_word: keyWord.value.trim(),
                  keyword_type: "商品名推荐搜索词",
                  result_number: resultsCount.getAttribute("data-count") || 0,
                  mkt_position_number: product.getAttribute("mkt_position"),
                  sku_id: getSku(),
                  sku_name: name,
                  sku_price: price,
                  commodity_tag: "",
                };
                const data = {
                  referer_page_type: "搜索结果",
                  referer_page: window.location.href,
                  key_word: SearchResultClick.key_word,
                  keyword_type: SearchResultClick.keyword_type,
                  click_id:
                    sensors.quick("getAnonymousID") +
                    new Date().getTime() +
                    SearchResultClick.sku_id,
                };
                rantionSetSessionStorage(product.getAttribute("href"), data);
                trackWithProductInfo("SearchResultClick", SearchResultClick);
              }
            });
          }
        }
      }
    }
  }
}

class LoginCradEventEvent {
  constructor() {
    this.page_login();
    this.page_crad();
  }
  page_login() {
    if (location.pathname == "/account/login") {
      document
        .querySelector(".form_login_btn")
        .addEventListener("click", () => {
          localStorage.setItem("sensors_is_login", 1);
        });
    }
    if (location.pathname == "/account/register") {
      document
        .querySelector(".form_register_btn")
        .addEventListener("click", () => {
          localStorage.setItem("sensors_is_register", 1);
          localStorage.setItem("sensors_is_login", 1);
        });
    }
  }
  page_crad() {
    if (location.pathname == "/cart") {
      document.querySelectorAll(".remove-sku-by-cart").forEach((item) => {
        item.addEventListener("click", (event) => {
          const dataset = event.target.dataset;
          this.removeFromCart({
            sku_id: dataset.sku,
            sku_name: event.target.getAttribute("aria-label"),
            sku_price: dataset.price / 100,
            sku_quantity: dataset.quantity,
          });
        });
      });
    }
  }
  removeFromCart(params) {
    trackWithProductInfo("RemoveFromCart", params);
  }
}

// 生成UUID
function fnGuid(str) {
  str = str || "xyxxxxyxxy";
  let d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  let uuid = str.replace(/[xy]/g, function (c) {
    let r = (d + Math.random() * 16) % 16 | 0; // d是随机种子
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

function genShareId() {
  return sensors.getPresetProperties()._distinct_id || fnGuid();
}
window.genShareId = function () {
  return genShareId.apply(this, arguments);
};
function randomString(length) {
  length = length || 8;
  let _charArr = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
    _str = "";
  for (i = 0; i < length; i++)
    _str += _charArr.charAt(Math.floor(Math.random() * _charArr.length));
  return _str;
}
window.randomString = function () {
  return randomString.apply(this, arguments);
};
function getRefererPageCookie(productId) {
  let { pathname, search } = window.location;
  let refererCookie = rantionGetSessionStorage(productId);
  if (pathname.indexOf("products") != -1) {
    if (refererCookie == null) {
      refererCookie =
        rantionGetSessionStorage(window.location.href) ||
        rantionGetSessionStorage(pathname + search) ||
        rantionGetSessionStorage(pathname);
    }
  }
  return {
    referer_page_type: "",
    click_id: "",
    referer_page: "",
    mkt_page: "",
    mkt_area: "",
    mkt_position_number: "",
    activity_page_name: "",
    key_word: "",
    keyword_type: "",
    ...refererCookie,
  };
}
function rantionSetSessionStorage(id, value) {
  sessionStorage.setItem(id, JSON.stringify(value));
}
function rantionGetSessionStorage(id) {
  const dataStr = sessionStorage.getItem(id);
  if (id) {
    try {
      return JSON.parse(dataStr);
    } catch (error) {
      return {};
    }
  }
}
window.getRefererPageCookie = function () {
  return getRefererPageCookie.apply(this, arguments);
};
const submitNowEventNames = ["SearchResultClick"];
class ProductTracker {
  constructor(cacheTTL = 5 * 60 * 1000) {
    this.skuCache = new Map();
    this.CACHE_TTL = cacheTTL;
    this.apiUrl =
      "https://api.rantion-admin.com/serverApi/rantion-etl/etlData/querySkuInformationBySkus";
  }
  trackWithProductInfo(eventName, eventData) {
    const skuId = eventData.sku_id;

    // 界面刷新无法 请求 会被中断  这些都立即提交
    const isAddCart =
      window.themeVariables.settings.pageType === "cart" &&
      eventName === "AddToCart";
    if (
      skuId == null ||
      skuId == "" ||
      submitNowEventNames.includes(eventName) ||
      isAddCart
    ) {
      this.sendTracking(eventName, eventData);
      return;
    }
    const cachedItem = this.getFromCache(skuId);
    if (cachedItem) {
      this.updateEventData(eventData, cachedItem);
      this.sendTracking(eventName, eventData);
      return;
    }
    this.fetchProductInfo(skuId)
      .then((productInfo) => {
        if (productInfo) {
          this.cacheProductInfo(skuId, productInfo);
          this.updateEventData(eventData, productInfo);
        } else {
          this.clearProductFields(eventData);
        }
        this.sendTracking(eventName, eventData);
      })
      .catch((error) => {
        console.error(
          "Sensors Track Error: ",
          eventName,
          eventData,
          "Fetch Error:",
          error
        );
        const oldCache = this.skuCache.get(skuId);
        if (oldCache) {
          this.updateEventData(eventData, oldCache.data);
          this.sendTracking(eventName, eventData);
        }
      });
  }
  async fetchProductInfo(skuId) {
    const response = await fetch(this.apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify([skuId]),
    });

    const result = await response.json();
    const resData = result.data;

    if (resData[0] && resData[0].sku && resData[0].sku === skuId) {
      return this.extractProductInfo(resData[0]);
    }

    return null;
  }

  extractProductInfo(apiResponse) {
    return {
      commodity_first_category: apiResponse.productLine1st,
      commodity_first_category_id: apiResponse.productLine1stCode,
      commodity_second_category: apiResponse.productLine2nd,
      commodity_second_category_id: apiResponse.productLine2ndCode,
      spu_id: apiResponse.spu,
      spu_name: apiResponse.spuName,
      sku_name: apiResponse.skuName || apiResponse.productNameCn,
    };
  }

  // 更新事件数据
  updateEventData(eventData, productInfo) {
    Object.keys(productInfo).forEach((key) => {
      if (productInfo[key] !== undefined && productInfo[key] !== null) {
        eventData[key] = productInfo[key];
      }
    });
  }

  // 清空商品相关字段
  clearProductFields(eventData) {
    const fields = [
      "commodity_first_category",
      "commodity_first_category_id",
      "commodity_second_category",
      "commodity_second_category_id",
      "spu_id",
      "spu_name",
      "sku_name",
    ];

    fields.forEach((field) => {
      eventData[field] = "";
    });
  }

  // 缓存商品信息
  cacheProductInfo(skuId, productInfo) {
    this.skuCache.set(skuId, {
      data: productInfo,
      timestamp: Date.now(),
    });
  }

  // 从缓存获取商品信息（检查有效期）
  getFromCache(skuId) {
    const cachedItem = this.skuCache.get(skuId);
    if (cachedItem && Date.now() - cachedItem.timestamp < this.CACHE_TTL) {
      return cachedItem.data;
    }
    return null;
  }

  // 发送追踪数据
  sendTracking(eventName, eventData) {
    sensors.track(eventName, eventData);
  }
}

const productTracker = new ProductTracker();

// 定义全局追踪函数
window.trackWithProductInfo = function (eventName, eventData) {
  productTracker.trackWithProductInfo(eventName, eventData);
};

window.rantionTrack = function (...arg) {
  console.log(arg);
};
class MktEvent {
  constructor() {
    this.init();
  }
  init() {
    document.querySelectorAll("[data-mkt_area]").forEach((item) => {
      const mktArea = item.getAttribute("data-mkt_area");
      const mktPositionNumber = getElementIndex(item) + 1;
      item.addEventListener("click", () => {
        const url = item.getAttribute("href");
        const mktClick = {
          mkt_area: mktArea,
          mkt_position_number: mktPositionNumber,
          ...getSensorsCommonParams(),
          mkt_page: "导航栏",
          referer_page_type: "导航栏",
        };
        if (url) {
          rantionSetSessionStorage(url, mktClick);
        }
        sensors.track("mktClick", mktClick);
      });
    });
    this.hdEamp();
    this.hdHomeAndBlogsAndCart();
    this.hdCollections();
    // 弹窗搜索
    this.hdSearch();
    this.hdProducts();
  }
  hdProducts() {
    function hdEve(link, name) {
      if (link) {
        const mktClick = {
          referer_page_type: "资源位",
          mkt_page: getMktPage(),
          mkt_area: name,
          referer_page: window.location.href,
          mkt_position_number: link.getAttribute("mkt_position"),
          mkt_material_id: link,
          mkt_material_name: link.getAttribute("alt"),
          sku_price: link.getAttribute("sku_price") / 100,
          click_id: sensors.quick("getAnonymousID") + new Date().getTime(),
        };
        sensors.track("mktClick", mktClick);
        rantionSetSessionStorage(link, mktClick);
      }
    }
    if (location.pathname.includes("products")) {
      const recommendations = document.querySelector("product-recommendations");
      if (recommendations) {
        recommendations.addEventListener("click", (event) => {
          const link = event.target.closest("a");
          hdEve(link, "You may also like");
        });
      }
      const viewed = document.querySelector("recently-viewed-products");
      if (viewed) {
        viewed.addEventListener("click", (event) => {
          const link = event.target.closest("a");
          hdEve(link, "Recently viewed products");
        });
      }
    }
  }
  hdSearch() {
    const data = {
      result_number: 0,
      key_word: "",
    };
    document.addEventListener("search:result", (event) => {
      const detail = event.detail;
      if (detail) {
        data.result_number = detail.result_number;
        data.key_word = detail.key_word;
        sensors.track("ReturnSearchResult", {
          ...detail,
          keyword_type: "商品名推荐搜索词",
        });
      }
    });
    const searchDrawer = document.querySelector("search-drawer");
    if (searchDrawer) {
      searchDrawer.addEventListener("click", (event) => {
        const product = event.target.closest("a");
        if (product) {
          let SearchResultClick = {
            ...data,
            keyword_type: "商品名推荐搜索词",
            mkt_position_number: product.getAttribute("mkt_position"),
            sku_id: product.getAttribute("mkt_sku"),
            sku_name: product.querySelector(".reversed-link").innerText.trim(),
            sku_price: product.getAttribute("mkt_price") / 100,
            commodity_tag: "",
          };
          rantionSetSessionStorage(product.getAttribute("href"), {
            referer_page_type: "搜索结果",
            referer_page: window.location.href,
            key_word: SearchResultClick.key_word,
            keyword_type: SearchResultClick.keyword_type,
            click_id:
              sensors.quick("getAnonymousID") +
              new Date().getTime() +
              SearchResultClick.sku_id,
          });
          trackWithProductInfo("SearchResultClick", SearchResultClick);
        }
      });
    }
  }
  hdCollections() {
    if (location.pathname.indexOf("collections") != -1) {
      const main = document.querySelector(".container");
      if (main) {
        main.addEventListener("click", function (e) {
          const link = e.target.closest("a");
          if (
            link &&
            link.href &&
            link.href.trim() !== "" &&
            link.href !== "#" &&
            this.contains(link)
          ) {
            const mkt_material_name =
              link.getAttribute("alt") || link.innerText;
            const mktClick = {
              referer_page_type: "资源位",
              mkt_page: getMktPage(),
              referer_page: window.location.href,
              click_id:
                sensors.quick("getAnonymousID") +
                new Date().getTime() +
                link.href,
              mkt_material_id: link,
              sku_price: link.getAttribute("sku_price") / 100,
              mkt_position_number: link.getAttribute("mkt_position"),
              mkt_material_name: mkt_material_name, //商品名称？ 我没有吧
            };
            sensors.track("mktClick", mktClick);
            rantionSetSessionStorage(link, mktClick);
          }
        });
      }
    }
  }
  hdHomeAndBlogsAndCart() {
    if (
      location.pathname === "/" ||
      location.pathname.includes("/blogs/") ||
      location.pathname === "/cart" ||
      location.pathname.includes("/collections/")
    ) {
      const main = document.getElementById("main");
      if (main) {
        main.addEventListener("click", function (e) {
          const link = e.target.closest("a");
          if (
            link &&
            link.href &&
            link.href.trim() !== "" &&
            link.href !== "#" &&
            this.contains(link)
          ) {
            const shopifySection = link.closest(".shopify-section");
            if (shopifySection) {
              const mkt_material_name =
                link.getAttribute("alt") || link.innerText;
              const mktClick = {
                referer_page_type: "资源位",
                mkt_page: getMktPage(),
                referer_page: window.location.href,
                mkt_position_number: link.getAttribute("mkt_position"),
                mkt_material_id: link.href,
                sku_price: link.getAttribute("sku_price") / 100,
                click_id:
                  sensors.quick("getAnonymousID") +
                  new Date().getTime() +
                  link.href,
                mkt_material_name: mkt_material_name, //商品名称？ 我没有吧
              };

              const _sectionName = Array.from(shopifySection.classList).find(
                (cls) => cls.startsWith("shopify-section--")
              );
              if (_sectionName) {
                mktClick.mkt_area = _sectionName.replace(
                  "shopify-section--",
                  ""
                );
                if (
                  mktClick.mkt_material_name == undefined ||
                  mktClick.mkt_material_name == ""
                ) {
                  mktClick.mkt_material_name = mktClick.mkt_area;
                }
              }
              if (link.closest(".you_may_also_like")) {
                mktClick.mkt_area = "You may also like";
              }
              const productCard = link.closest("product-card");
              if (productCard) {
                mktClick.mkt_material_id =
                  productCard.getAttribute("data-skuid");
              }
              sensors.track("mktClick", mktClick);
              rantionSetSessionStorage(link, mktClick);
            }
          }
        });
      }
    }
  }
  // 万能活动界面
  hdEamp() {
    const eampElement = document.getElementById("eamp");
    if (eampElement) {
      eampElement.addEventListener("click", function (e) {
        // 检查点击的是否是 <a> 标签
        const link = e.target.closest("a");
        if (
          link &&
          link.href &&
          link.href.trim() !== "" &&
          link.href !== "#" &&
          this.contains(link)
        ) {
          const mktClick = {
            referer_page_type: "活动页",
            mkt_page: "活动页",
            referer_page: window.location.href,
            click_id: sensors.quick("getAnonymousID") + new Date().getTime(),
          };
          const eamp_block = link.closest(".eamp_block");
          if (eamp_block) {
            mktClick.mkt_area = eamp_block.dataset.eamp_block;
            mktClick.mkt_material_name = mktClick.mkt_area;
          }
          rantionSetSessionStorage(link, mktClick);
        }
      });
    }
  }
  setMktArea(key, data) {
    rantionSetSessionStorage(key, {
      mkt_page: getMktPage(),
      // mkt_area: scookie.mkt_area, // 模块名可以获取到则取模块名
      // mkt_position_number: scookie.mkt_position_number,
      referer_page_type: "资源位",
      referer_page: window.location.href,
      mkt_material_id: "", // 资源位内素材为图片链接时，传链接URL。资源位内素材为商品时，传商品SPUID/SKUID，
      mkt_material_name: "", // 资源位为图片链接时，传物料名（banner名、活动名等）。 资源位为商品时：传商品SPU/SKU名，
      click_id:
        sensors.quick("getAnonymousID") +
        new Date().getTime() +
        scookie.mkt_material_id,
      ...data,
    });
  }
}
// 加购 和立即购买事件
class CartBuyNowEvent {
  constructor() {
    try {
      const variant = JSON.parse(
        document.querySelector("script[data-variant]")?.textContent || "{}"
      );
      const product = JSON.parse(
        document.querySelector("script[data-product-json]")?.textContent || "{}"
      );
      this.product = product.product ?? {};
      if (location.pathname.includes("/products/")) {
        this.CommodityDetailView(variant);
        this.variantChange(this.product);
      }
    } catch (error) {
      this.product = {};
      console.error("上报产品浏览【CommodityDetailView】失败", error);
    }
    this.addToCart();
    this.buyNow();
  }
  buyNow() {
    document.addEventListener("buyNow", (event) => {
      if (event.detail) {
        event.detail.forEach((item) => {
          const comdata = this.hdProducts(event, {
            ...getSensorsCommonParams(),
            ...this.hdAddToCart(event),
          });
          trackWithProductInfo("BuyNow", {
            ...comdata,
            sku_id: item.sku,
            sku_name: item.title,
            sku_price: item.price / 100,
            sku_quantity: item.quantity || 1,
          });
        });
      }
    });
  }

  getVariants(id) {
    if (this.product && this.product.variants) {
      return this.product.variants.find((variant) => variant.id == id);
    } else {
      // 尝试从页面脚本中获取变体信息(非产品界面)
      try {
        const variant = JSON.parse(
          document.querySelector("script[data-variant]")?.textContent || "{}"
        );
        if (variant && variant.id == id) {
          return variant;
        }
        return null;
      } catch (e) {
        return null;
      }
    }
  }
  hdAddToCart(event) {
    const data = {};
    if (location.pathname.indexOf("products") === -1) {
      const drawer = event.target.closest("quick-buy-drawer");
      if (drawer) {
        const id = drawer.getAttribute("id");
        if (id) {
          const dom = document.querySelector('[aria-controls="' + id + '"]');
          const section = dom.closest(".shopify-section");
          if (section) {
            data.referer_page_type = "资源位";
            data.mkt_page = getMktPage();
            data.mkt_position_number = getElementIndex(section) + 1;
            data.mkt_area = extractShopifySectionId(section);
            return data;
          }
        }
      } else {
        const section = event.target.closest(".shopify-section");
        if (section) {
          data.referer_page_type = "资源位";
          data.mkt_page = getMktPage();
          data.mkt_position_number = getElementIndex(section) + 1;
          data.mkt_area = extractShopifySectionId(section);
          return data;
        }
      }
      // 不是首页 可能是活动界面  试试
      const eamp = event.target.closest("#eamp");
      if (eamp) {
        data.referer_page_type = "活动页";
        data.mkt_page = "活动页";
        const eamp_block = event.target.closest(".eamp_block");
        if (eamp_block) {
          data.mkt_area = eamp_block.dataset.eamp_block;
        }
        return data;
      }
    }
    return data;
  }
  // 我猜你喜欢 & 最近查看
  hdProducts(event, data) {
    if (location.pathname.indexOf("products") != -1) {
      const scookie = this.getScookie();
      data = {
        ...data,
        ...scookie,
      };
      const drawer = event.target.closest("quick-buy-drawer");
      if (drawer) {
        const id = drawer.getAttribute("id");
        if (id) {
          const dom = document.querySelector('[aria-controls="' + id + '"]');
          const section = dom.closest(".shopify-section");
          if (section) {
            data.referer_page_type = "资源位";
            data.mkt_page = getMktPage();
            data.mkt_position_number = getElementIndex(section) + 1;
            data.mkt_area = extractShopifySectionId(section);
            return data;
          }
        }
      }
      const productRecommendations = event.target.querySelector(
        "product-recommendations"
      );
      if (productRecommendations) {
        // You may also like
        data.referer_page_type = "资源位";
        data.mkt_page = getMktPage();
        data.mkt_area = "You may also like";
        return data;
      }
      const viewed = event.target.querySelector("recently-viewed-products");
      if (viewed) {
        // You may also like
        data.referer_page_type = "资源位";
        data.mkt_page = getMktPage();
        data.mkt_area = "Recently viewed products";
        return data;
      }
      // 空的删除这些
      if (Object.keys(scookie).length === 0) {
        data.mkt_area = "";
        data.mkt_page = "";
        data.referer_page_type = "";
      }
    }
    return data;
  }
  addToCart() {
    document.addEventListener("cart:add", (event) => {
      const detail = event.detail;
      if (detail) {
        let comdata = {
          ...getSensorsCommonParams(),
          ...this.hdAddToCart(event),
        };
        comdata = this.hdProducts(event, comdata);
        detail.forEach((item) => {
          const { quantity, id, sku, title, price } = item;
          if (id) {
            if (sku) {
              const data = {
                ...comdata,
                sku_id: sku,
                sku_name: title,
                sku_price: price / 100,
                sku_quantity: quantity || 1,
              };
              trackWithProductInfo("AddToCart", data);
              this.updateScookie(sku, data);
            } else {
              const variant = this.getVariants(id);
              if (variant) {
                const data = {
                  ...comdata,
                  sku_id: variant.sku,
                  sku_name: variant.title || variant.name,
                  sku_price: variant.price / 100,
                  sku_quantity: quantity || 1,
                  commodity_tag: this.product.tags
                    ? this.product.tags.join(",")
                    : "",
                };
                this.updateScookie(data.sku_id, data);
                trackWithProductInfo("AddToCart", data);
              }
            }
          }
        });
      }
    });
  }
  getScookie() {
    let scookie = getRefererPageCookie(this.product.id);
    if (scookie && scookie.click_id) {
      // sessionStorage.removeItem(this.product.id);
      // let { pathname, search } = window.location;
      // sessionStorage.removeItem(window.location.href);
      // sessionStorage.removeItem(pathname);
      // sessionStorage.removeItem(pathname + search);
    }
    return removeEmptyValues(scookie);
  }
  updateScookie(sku, updateScookie) {
    if (sku) {
      rantionSetSessionStorage(sku, updateScookie);
      let { pathname, search } = window.location;
      sessionStorage.removeItem(window.location.href);
      sessionStorage.removeItem(pathname);
      sessionStorage.removeItem(pathname + search);
    }
  }
  variantChange() {
    document.addEventListener("variant:change", (res) => {
      this.CommodityDetailView(res.detail.variant);
    });
  }
  CommodityDetailView(variant) {
    trackWithProductInfo("CommodityDetailView", {
      ...this.getScookie(),
      sku_id: variant.sku,
      sku_name: variant.name || variant.title,
      sku_price: variant.price / 100,
      commodity_tag: this.product.tags.join(",") || "",
    });
  }
}

function init(data) {
  sensors.init({
    server_url: "https://datasink.rantion-admin.com/sa?project=production",
    heatmap: {
      clickmap: "default",
      scroll_notice_map: "default",
      collect_tags: {
        div: {
          max_level: 1,
        },
        img: true,
      },
    },
    preset_properties: {
      latest_landing_page: true,
    },
    is_track_single_page: true,
    source_channel: ["gclid", "fbclid", "msclkid", "ttclid", "cppv"],
    show_log: localStorage.getItem("sensors_show_log") == 1,
    max_referrer_string_length: 600,
  });
  registerPage(data); //  先注册一次同步的属性
  getExchangeRate(window.Rantion.sc_currency_country, (exchange_rate) =>
    registerPage(data, exchange_rate)
  );
  sensors.quick("autoTrack");
  sensors.use("PageLeave");
  if (data) {
    login(data.email);
    sensorHandleRegister(data);
    sensorHandleLogin(data.email);
  }
  new LoginCradEventEvent();
  new CartBuyNowEvent();
  new MktEvent();
  new FoorerAndHeader();
  document.body.addEventListener("copy:code", (event) => {
    const data = event.detail;
    console.log("复制优惠码", data);
    sensors.track("GainCoupons", {
      coupons_type: data.type || "专属活动优惠券",
      coupons_name: data.name,
      coupons_code: data.cdoe,
      coupons_amount: data.amount || "",
      coupons_percent: data.percent || "",
    });
  });
}
function login(email) {
  sensors.login(email);
}
function sensorHandleRegister(customer) {
  let sensorsIsRegister = localStorage.getItem("sensors_is_register");
  if (
    sensorsIsRegister != null &&
    sensorsIsRegister == 1 &&
    customer.email != null
  ) {
    sensors.track("RegisterResult", {
      register_email: customer.email,
      is_success: true,
      fail_reason: "",
    });
    sensors.setProfile({
      register_email: customer.email,
      name: customer.name,
    });
  }
  localStorage.removeItem("sensors_is_register");
}
function sensorHandleLogin(email) {
  let sensorsIsLogin = localStorage.getItem("sensors_is_login");
  if (sensorsIsLogin != null && sensorsIsLogin == 1 && email != null) {
    sensors.track("LoginResult", {
      login_channel: "邮箱",
      login_email: email,
      is_success: true,
      fail_reason: "",
    });
    sensors.setProfile({
      register_email: email,
    });
  }
  localStorage.removeItem("sensors_is_login");
}

export { init };
